import React, { ComponentProps } from 'react';

import * as Switch from '@radix-ui/react-switch';

import styles from './Switch.module.css';

type SwitchProps = Omit<ComponentProps<typeof Switch.Root>, 'onChange' | 'defaultValue'> & {
  disabled?: boolean;
  defaultValue?: boolean;
  thinVariant?: boolean;
  onChange?: (value: boolean) => void;
  value?: boolean;
};

export function SwitchComponent({
  disabled,
  defaultValue,
  thinVariant,
  onChange,
  value,
  ref,
  ...rest
}: SwitchProps & { ref?: React.Ref<React.ComponentRef<typeof Switch.Root>> }) {
  return (
    <Switch.Root
      defaultChecked={defaultValue}
      ref={ref}
      disabled={disabled}
      onCheckedChange={onChange}
      checked={value}
      className={thinVariant ? styles.switchRootSmall : styles.switchRoot}
      title=''
      {...rest}
    >
      <Switch.Thumb tabIndex={0} className={thinVariant ? styles.switchThumbSmall : styles.switchThumb} />
    </Switch.Root>
  );
}
